import { Card, Chip } from '@heroui/react';
import { AlertTriangle, Sparkles } from 'lucide-react';
import type { VisitDetail } from '@/store/visitDetailSlice';

interface VisitAiCardProps {
  visit: VisitDetail;
}

export function VisitAiCard({ visit }: VisitAiCardProps) {
  const { aiOutput, aiError } = visit;
  if (!aiOutput && !aiError) return null;

  return (
    <Card className="bg-surface">
      <Card.Header className="flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Sparkles className="size-5 text-accent" />
          <Card.Title>AI-анализ визита</Card.Title>
        </div>
        {aiOutput?.overall_class && (
          <Chip size="sm" variant="soft" color="accent">
            {aiOutput.overall_class}
          </Chip>
        )}
      </Card.Header>
      <Card.Content className="flex flex-col gap-3">
        {aiError && (
          <div className="rounded-[var(--radius)] bg-danger px-3 py-2 text-sm text-danger-foreground">
            {aiError}
          </div>
        )}
        {aiOutput?.summary && <p className="text-sm text-foreground">{aiOutput.summary}</p>}
        {aiOutput?.issues && aiOutput.issues.length > 0 && (
          <ul className="flex flex-col gap-2">
            {aiOutput.issues.map((issue, index) => (
              <li
                key={index}
                className="flex items-start gap-2 rounded-[var(--radius)] bg-surface-secondary px-3 py-2 text-sm text-foreground"
              >
                <AlertTriangle className="mt-0.5 size-4 shrink-0 text-warning" />
                <span>{issue}</span>
              </li>
            ))}
          </ul>
        )}
      </Card.Content>
    </Card>
  );
}
